// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #e84200;
    --red: #fa2d00;
    --grey1: #d7d7d7;
    --grey2: #d9d9d9;
    --grey4: #a1a1a1;
    --darkgrey1: #222222;
    --darkgrey3: #000000;
    --white: #ffffff;
}

.custom-order-page {
    max-width: 1320px;
    margin: 0 auto;
    padding: 40px 20px;
    font-family: 'Noto Sans KR', sans-serif;
}

.co-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.co-progress-indicator {
    width: 466px;
    max-width: 100%;
    height: 90px;
    position: relative;
    margin: 40px auto;
    padding: 0;
}

.co-progress-line-bg {
    background: #d9d9d9;
    width: calc(100% - 25px);
    height: 3px;
    position: absolute;
    left: 25px;
    right: 0;
    top: 12px;
    z-index: 1;
}

.co-progress-line-fill {
    background: var(--primary, #e84200);
    width: 0;
    height: 3px;
    position: absolute;
    left: 25px;
    top: 12px;
    z-index: 2;
    transition: width 0.3s ease;
}

.co-progress-line-fill.step2 {
    width: calc(50% - 12.5px);
}

.co-progress-line-fill.step3 {
    width: calc(100% - 25px);
}

/* step-label 활성화 시 스타일 */
.co-progress-indicator .step-item.active .step-label {
    font-weight: 700;
    color: var(--primary, #e84200);
}

.co-progress-indicator .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    z-index: 3;
    width: auto;
    max-width:20px;
    box-sizing: border-box;
}

/* step-item 순서: (3)도면첨부 왼쪽, (4)입력한 내용 확인 가운데, (5)견적 요청 완료 오른쪽 */
.co-progress-indicator .step-item:nth-child(3) {
    left: 12.5px;
    top: 0;
    transform: translateX(-50%);
}

.co-progress-indicator .step-item:nth-child(4) {
    left: 50%;
    transform: translateX(-50%);
    top: 0;
}

.co-progress-indicator .step-item:last-child {
    right: 12.5px;
    top: 0;
    transform: translateX(50%);
}

.step-dot {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--grey2, #d9d9d9);
    flex-shrink: 0;
    position: relative;
    margin-bottom: 20px;
}

.co-progress-indicator .step-item.active .step-dot,
.step-dot.active {
    background: var(--primary, #e84200);
}

.step-label {
    color: var(--darkgrey3, #000000);
    text-align: center;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    white-space: normal;
    word-break: keep-all;
    max-width: 100%;
    overflow-wrap: break-word;
    width: 100%;
    min-width: 100px;
    display: block;
    margin: 0 auto;
}

.co-step-container {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 20px;
}

.co-title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
}

.co-description {
    font-size: 16px;
    color: #555;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
    margin-bottom: 40px;
    text-align: left;
}

/* Step 1 Styles */
.file-upload-section {
    background: #f1f1f1;
    width: 100%;
    min-height: 315px;
    position: relative;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
}

.upload-btn-wrapper {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
}

.upload-btn {
    flex-shrink: 0;
    width: 249px;
    height: 53px;
    position: relative;
    background: var(--primary, #e84200);
    border-radius: 5px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-btn div {
    color: var(--white, #ffffff);
    text-align: center;
    font-family: "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
}

.upload-text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 9px;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: 0;
}

.upload-main-text {
    color: var(--darkgrey3, #000000);
    text-align: center;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.upload-note {
    color: var(--primary, #e84200);
    text-align: center;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    font-weight: 500;
    margin: 0;
}

.form-header {
    display: flex;
    flex-direction: column;
    gap: 25px;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 64px;
}

.form-header-inner {
    display: flex;
    flex-direction: row;
    gap: 25px;
    align-items: flex-end;
    justify-content: flex-start;
    align-self: stretch;
    position: relative;
}

.form-header h3 {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 28px;
    font-weight: 600;
    margin: 0;
}

.load-info-btn {
    background: var(--darkgrey3, #000000);
    border-radius: 5px;
    padding: 15px;
    color: var(--white, #ffffff);
    text-align: center;
    font-family: "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
    border: none;
    cursor: pointer;
    width: 178px;
    height: 53px;
    position: absolute;
    right: 0;
    bottom: -13px;
}

.form-header-divider {
    margin-top: -1px;
    border-style: solid;
    border-color: var(--darkgrey1, #222222);
    border-width: 1px 0 0 0;
    align-self: stretch;
    height: 0px;
}

.form-grid {
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0;
    margin-bottom: 47px;
    width: 100%;
    border-bottom: none;
}

.form-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    position: relative;
    min-height: 53px;
    gap: 0;
    border-bottom: none;
}

.form-row label {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    font-weight: 400;
    min-width: 200px;
    flex-shrink: 0;
    white-space: nowrap;
    background-color: transparent !important;
    background: transparent !important;
    padding: 0 20px;
    height: 53px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.form-row .required {
    color: var(--red, #fa2d00);
}

.input-wrapper {
    flex: 1 1;
    height: 53px;
    position: relative;
    min-width: 0;
}

.form-row input {
    background: var(--white, #ffffff);
    border-radius: 5px;
    border-style: solid;
    border-color: var(--grey1, #d7d7d7);
    border-width: 1px;
    width: 100%;
    height: 53px;
    padding: 0 16px;
    box-sizing: border-box;
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    color: var(--darkgrey3, #000000);
}

.form-row input::placeholder {
    color: var(--grey4, #a1a1a1);
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
}

.form-display-value {
    background: var(--white, #ffffff);
    border-radius: 5px;
    border-style: solid;
    border-color: var(--grey1, #d7d7d7);
    border-width: 1px;
    width: 100%;
    height: 53px;
    padding: 0 16px;
    box-sizing: border-box;
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    color: var(--darkgrey3, #000000);
    display: flex;
    align-items: center;
}

.phone-row {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: flex-start;
    width: 100%;
    position: relative;
}

.phone-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0;
    flex: 1 1;
    min-height: 53px;
}

.phone-group label {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    font-weight: 400;
    min-width: 120px;
    flex-shrink: 0;
    white-space: nowrap;
    background-color: transparent !important;
    background: transparent !important;
    padding: 0 20px;
    height: 53px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.phone-group .input-wrapper {
    flex: 1 1;
    height: 53px;
    position: relative;
    min-width: 0;
}

.phone-inputs {
    display: flex;
    align-items: center;
    gap: 10px;
}
.phone-inputs input {
    flex-grow: 1;
}
.phone-inputs .mobile-label {
    margin-bottom: 0;
    margin-left: 20px;
    flex-shrink: 0;
}

.co-actions {
    display: flex;
    justify-content: center;
    margin-top: 60px;
}

.co-actions.space-between {
    justify-content: space-between;
}

.confirm-btn-large {
    background-color: #E84100;
    color: white;
    padding: 20px 80px;
    border: none;
    border-radius: 5px;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
}

/* Step 2 Styles */
.attached-files-summary {
    background-color: #f8f8f8;
    padding: 20px;
    margin-bottom: 40px;
}

.remove-file-btn {
    background: var(--darkgrey3, #000000);
    color: var(--white, #ffffff);
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s ease;
}

.remove-file-btn:hover {
    background: #333333;
}

.file-item {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}
.file-item .file-status {
    color: #E84100;
}

.user-info-summary {
    border-top: 2px solid #222;
}
.info-row {
    display: flex;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;
}
.info-row .label {
    flex-basis: 150px;
    font-weight: 500;
}

.edit-btn-text {
    background: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    font-size: 15px;
    color: #555;
}

.back-btn, .confirm-btn {
    padding: 15px 40px;
    border-radius: 5px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    border: 1px solid;
    width: 250px;
    text-align: center;
}

.back-btn {
    background-color: white;
    border-color: #ccc;
    color: #333;
}

.confirm-btn {
    background-color: #E84100;
    border-color: #E84100;
    color: white;
}


.co-actions .edit-btn-text.right {
    background: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    font-size: 15px;
    color: #555;
    margin-left: auto;
}

.centered-content {
    padding: 100px 0;
    text-align: center;
}
.centered-content .co-title { text-align: center; }
.centered-content .co-description {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    border-bottom: none;
}
.black-btn {
    background-color: #222;
    color: white;
    border: none;
    padding: 15px 60px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.black-btn:hover {
    background-color: #333;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

/* 커스텀 주문 2단계와 3단계 버튼들 */
.button-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0;
    margin-bottom: 0;
    width: 100%;
    gap: 20px;
}

.button-container .submit-btn {
    background: var(--primary, #e84200);
    border-radius: 5px;
    padding: 15px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
    flex: 1 1;
    height: 53px;
    border: none;
    cursor: pointer;
}

.button-container .submit-btn div {
    color: var(--white, #ffffff);
    text-align: center;
    font-family: "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
}

.prev-btn, .submit-btn, .reset-btn, .list-btn {
    padding: 15px 40px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease;
    flex: 1 1;
}

.prev-btn {
    background-color: #f8f9fa;
    color: #333;
    border: 1px solid #dee2e6;
}

.prev-btn:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
    transform: translateY(-1px);
}

.submit-btn, .reset-btn, .list-btn {
    background-color: #E84100;
    color: white;
    box-shadow: 0 2px 4px rgba(232, 65, 0, 0.2);
}

.submit-btn:hover, .reset-btn:hover, .list-btn:hover {
    background-color: #d73502;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(232, 65, 0, 0.3);
}

.submit-btn:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* Step 2 확인 페이지 스타일 */
.confirmation-section {
    background-color: #ffffff;
    padding: 30px;
    border-radius: 8px;
    margin-bottom: 30px;
}

.confirmation-section h3 {
    color: var(--darkgrey3, #000000);
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 20px 0;
    padding-bottom: 15px;
    border-bottom: 2px solid var(--darkgrey1, #222222);
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
}

.info-item {
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Regular", sans-serif;
    font-size: 16px;
    line-height: 1.6;
}

.info-item strong {
    font-weight: 600;
    margin-right: 10px;
}

.files-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.file-confirmation-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background-color: white;
    border-radius: 4px;
}

.file-confirmation-item .file-name {
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Regular", sans-serif;
    font-size: 16px;
}

.file-confirmation-item .file-size {
    color: var(--grey4, #a1a1a1);
    font-family: "Inter-Regular", sans-serif;
    font-size: 14px;
}

.additional-request-text {
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Regular", sans-serif;
    font-size: 16px;
    line-height: 1.6;
    white-space: pre-wrap;
    margin: 0;
}

/* 완료 페이지 스타일 */
.completion-message {
    text-align: center;
    padding: 60px 20px;
    background-color: #ffffff;
    border-radius: 8px;
    margin-bottom: 40px;
}

.completion-title {
    font-size: 24px;
    font-weight: 700;
    color: var(--darkgrey3, #000000);
    margin: 0 0 20px 0;
    font-family: "Inter-Bold", sans-serif;
}

.completion-description {
    font-size: 16px;
    line-height: 1.6;
    margin: 0;
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Regular", sans-serif;
}

.success-icon {
    font-size: 60px;
    color: #28a745;
    margin-bottom: 20px;
}

.completion-message p {
    font-size: 18px;
    line-height: 1.5;
    margin-bottom: 10px;
    color: #333;
}

.step3-button {
    justify-content: center;
}

.back-to-list-btn {
    background-color: var(--darkgrey3, #000000);
    color: var(--white, #ffffff);
    border: none;
    border-radius: 5px;
    padding: 15px 40px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "Inter-Bold", sans-serif;
    min-width: 200px;
}

.back-to-list-btn:hover {
    background-color: #333333;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .custom-order-page {
        padding: 20px;
    }

    .co-title {
        font-size: 30px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .custom-order-page {
        padding: 15px;
        max-width: 100%;
    }
    
    .co-step-container {
        padding: 0 15px;
        max-width: 100%;
    }

    .co-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
        padding: 0 5px;
    }

    .co-title {
        font-size: 20px;
        margin-bottom: 8px;
    }
    
    .co-description {
        font-size: 14px;
        padding-bottom: 20px;
        margin-bottom: 30px;
    }
    
    .co-progress-indicator {
        width: 100%;
        max-width: 100%;
        height: auto;
        min-height: 90px;
        margin: 40px auto;
        padding: 0 10px;
        box-sizing: border-box;
    }
    
    .co-progress-line-bg {
        width: calc(100% - 25px);
        left: 12.5px;
        right: 12.5px;
    }
    
    .co-progress-line-fill {
        left: 12.5px;
    }
    
    .co-progress-line-fill.step2 {
        width: calc(50% - 12.5px);
    }
    
    .co-progress-line-fill.step3 {
        width: calc(100% - 25px);
    }
    
    .co-progress-indicator .step-item {
        max-width: calc(33.333% - 5px);
        padding: 0 5px;
        box-sizing: border-box;
    }

    .co-progress-indicator .step-item:nth-child(3) {
        left: 12.5px;
        transform: translateX(-50%);
    }
    
    .co-progress-indicator .step-item:nth-child(4) {
        left: 50%;
        transform: translateX(-50%);
    }
    
    .co-progress-indicator .step-item:last-child {
        right: 12.5px;
        transform: translateX(50%);
    }

    .step-label {
        font-size: 12px;
        line-height: 1.3;
        white-space: normal;
        word-break: keep-all;
        max-width: 100%;
        overflow-wrap: break-word;
        width: 100%;
        display: block;
        margin: 0 auto;
    }
    
    .file-upload-section {
        padding: 30px 15px;
        margin-bottom: 30px;
        min-height: 200px;
    }
    
    .upload-text-wrapper {
        gap: 8px;
    }

    .upload-main-text,
    .upload-note {
        font-size: 14px;
    }

    .upload-btn {
        width: 100%;
        max-width: 249px;
        height: 48px;
    }
    
    .upload-btn div {
        font-size: 16px;
    }
    
    .form-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-bottom: 30px;
    }
    
    .form-header h3 {
        font-size: 20px;
    }

    .form-header-inner {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        width: 100%;
    }

    .load-info-btn {
        position: static;
        width: 100%;
        max-width: 178px;
        height: 48px;
        font-size: 16px;
        bottom: 0;
    }
    
    .form-grid {
        padding: 0;
        gap: 20px;
        margin-bottom: 30px;
    }

    .form-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        min-height: auto;
        width: 100%;
    }

    .form-row label {
        position: static;
        min-width: auto;
        width: 100%;
        margin-bottom: 5px;
        padding: 12px 15px;
        height: auto;
        font-size: 14px;
        background-color: transparent !important;
        background: transparent !important;
    }

    .input-wrapper {
        width: 100%;
        margin-left: 0;
        height: auto;
    }
    
    .form-row input {
        height: 48px;
        font-size: 16px;
        padding: 0 12px;
    }
    
    .form-row input::placeholder {
        font-size: 16px;
    }

    .form-display-value {
        height: 48px;
        font-size: 16px;
        padding: 0 12px;
    }

    .phone-row {
        flex-direction: column;
        gap: 20px;
        width: 100%;
    }

    .phone-group {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .phone-group label {
        min-width: auto;
        width: 100%;
        margin-bottom: 5px;
        padding: 12px 15px;
        height: auto;
        font-size: 14px;
        background-color: transparent !important;
        background: transparent !important;
    }
    
    .phone-group .input-wrapper {
        width: 100%;
    }

    .co-actions {
        flex-direction: column;
        gap: 10px;
        margin-top: 30px;
        width: 100%;
    }

    .co-actions.space-between {
        flex-direction: column-reverse;
    }

    .confirm-btn-large, .back-btn, .confirm-btn, .black-btn {
        width: 100%;
        padding: 15px;
        font-size: 16px;
    }

    .button-container {
        width: 100%;
        padding: 0;
        gap: 10px;
    }
    
    .button-container .submit-btn,
    .button-container .prev-btn,
    .button-container .reset-btn,
    .button-container .list-btn {
        flex: 1 1;
        width: auto;
        min-width: 0;
        height: 48px;
        padding: 15px 20px;
        font-size: 16px;
    }
    
    .button-container .submit-btn div {
        font-size: 16px;
    }

    .info-row {
        flex-direction: column;
        align-items: flex-start;
        padding: 15px 10px;
        gap: 8px;
    }
    
    .info-row .label {
        flex-basis: auto;
        margin-bottom: 5px;
        font-size: 14px;
    }
    
    .attached-files-summary {
        padding: 15px;
        margin-bottom: 30px;
    }
    
    .file-item {
        flex-direction: column;
        gap: 8px;
        padding: 12px;
    }

    .centered-content {
        padding: 40px 0;
    }
    
    .completion-message {
        padding: 40px 15px;
        margin-bottom: 30px;
    }

    .completion-title {
        font-size: 20px;
    }

    .completion-description {
        font-size: 14px;
        line-height: 1.5;
    }
    
    .completion-message p {
        font-size: 16px;
    }

    .back-to-list-btn {
        width: 100%;
        max-width: 100%;
        padding: 15px 20px;
        font-size: 16px;
    }

    .step3-button {
        width: 100%;
    }

    .confirmation-section {
        padding: 20px 15px;
        margin-bottom: 20px;
    }

    .confirmation-section h3 {
        font-size: 20px;
        margin-bottom: 15px;
        padding-bottom: 10px;
    }

    .info-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .info-item {
        font-size: 14px;
    }

    .file-confirmation-item {
        padding: 8px;
    }

    .file-confirmation-item .file-name {
        font-size: 14px;
    }

    .file-confirmation-item .file-size {
        font-size: 12px;
    }

    .additional-request-text {
        font-size: 14px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/CustomOrderPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;IACd,sBAAsB;AAC1B;;AAEA,gEAAgE;AAChE;IACI,YAAY;IACZ,MAAM;IACN,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,MAAM;AACV;;AAEA;IACI,aAAa;IACb,MAAM;IACN,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,wCAAwC;IACxC,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,wCAAwC;IACxC,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,MAAM;IACN,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA,8BAA8B,kBAAkB,EAAE;AAClD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,SAAO;AACX;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;AACb;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2CAA2C;IAC3C,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;QAC9B,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,SAAS;QACT,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;QACpB,eAAe;QACf,yBAAyB;QACzB,WAAW;QACX,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,SAAS;IACb;;IAEA;QACI,UAAU;QACV,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,wCAAwC;QACxC,kCAAkC;IACtC;;IAEA;QACI,WAAW;QACX,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,wCAAwC;QACxC,kCAAkC;IACtC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;;IAEA;;;;QAII,SAAO;QACP,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    --primary: #e84200;\n    --red: #fa2d00;\n    --grey1: #d7d7d7;\n    --grey2: #d9d9d9;\n    --grey4: #a1a1a1;\n    --darkgrey1: #222222;\n    --darkgrey3: #000000;\n    --white: #ffffff;\n}\n\n.custom-order-page {\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 40px 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.co-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.co-progress-indicator {\n    width: 466px;\n    max-width: 100%;\n    height: 90px;\n    position: relative;\n    margin: 40px auto;\n    padding: 0;\n}\n\n.co-progress-line-bg {\n    background: #d9d9d9;\n    width: calc(100% - 25px);\n    height: 3px;\n    position: absolute;\n    left: 25px;\n    right: 0;\n    top: 12px;\n    z-index: 1;\n}\n\n.co-progress-line-fill {\n    background: var(--primary, #e84200);\n    width: 0;\n    height: 3px;\n    position: absolute;\n    left: 25px;\n    top: 12px;\n    z-index: 2;\n    transition: width 0.3s ease;\n}\n\n.co-progress-line-fill.step2 {\n    width: calc(50% - 12.5px);\n}\n\n.co-progress-line-fill.step3 {\n    width: calc(100% - 25px);\n}\n\n/* step-label 활성화 시 스타일 */\n.co-progress-indicator .step-item.active .step-label {\n    font-weight: 700;\n    color: var(--primary, #e84200);\n}\n\n.co-progress-indicator .step-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    position: absolute;\n    z-index: 3;\n    width: auto;\n    max-width:20px;\n    box-sizing: border-box;\n}\n\n/* step-item 순서: (3)도면첨부 왼쪽, (4)입력한 내용 확인 가운데, (5)견적 요청 완료 오른쪽 */\n.co-progress-indicator .step-item:nth-child(3) {\n    left: 12.5px;\n    top: 0;\n    transform: translateX(-50%);\n}\n\n.co-progress-indicator .step-item:nth-child(4) {\n    left: 50%;\n    transform: translateX(-50%);\n    top: 0;\n}\n\n.co-progress-indicator .step-item:last-child {\n    right: 12.5px;\n    top: 0;\n    transform: translateX(50%);\n}\n\n.step-dot {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: var(--grey2, #d9d9d9);\n    flex-shrink: 0;\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.co-progress-indicator .step-item.active .step-dot,\n.step-dot.active {\n    background: var(--primary, #e84200);\n}\n\n.step-label {\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    white-space: normal;\n    word-break: keep-all;\n    max-width: 100%;\n    overflow-wrap: break-word;\n    width: 100%;\n    min-width: 100px;\n    display: block;\n    margin: 0 auto;\n}\n\n.co-step-container {\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.co-title {\n    font-size: 36px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    text-align: left;\n}\n\n.co-description {\n    font-size: 16px;\n    color: #555;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #eee;\n    margin-bottom: 40px;\n    text-align: left;\n}\n\n/* Step 1 Styles */\n.file-upload-section {\n    background: #f1f1f1;\n    width: 100%;\n    min-height: 315px;\n    position: relative;\n    margin-bottom: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n}\n\n.upload-btn-wrapper {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    gap: 20px;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 20px;\n}\n\n.upload-btn {\n    flex-shrink: 0;\n    width: 249px;\n    height: 53px;\n    position: relative;\n    background: var(--primary, #e84200);\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.upload-btn div {\n    color: var(--white, #ffffff);\n    text-align: center;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.upload-text-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    margin-top: 0;\n}\n\n.upload-main-text {\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.upload-note {\n    color: var(--primary, #e84200);\n    text-align: center;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.form-header {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-bottom: 64px;\n}\n\n.form-header-inner {\n    display: flex;\n    flex-direction: row;\n    gap: 25px;\n    align-items: flex-end;\n    justify-content: flex-start;\n    align-self: stretch;\n    position: relative;\n}\n\n.form-header h3 {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 28px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.load-info-btn {\n    background: var(--darkgrey3, #000000);\n    border-radius: 5px;\n    padding: 15px;\n    color: var(--white, #ffffff);\n    text-align: center;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    border: none;\n    cursor: pointer;\n    width: 178px;\n    height: 53px;\n    position: absolute;\n    right: 0;\n    bottom: -13px;\n}\n\n.form-header-divider {\n    margin-top: -1px;\n    border-style: solid;\n    border-color: var(--darkgrey1, #222222);\n    border-width: 1px 0 0 0;\n    align-self: stretch;\n    height: 0px;\n}\n\n.form-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 0;\n    margin-bottom: 47px;\n    width: 100%;\n    border-bottom: none;\n}\n\n.form-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    position: relative;\n    min-height: 53px;\n    gap: 0;\n    border-bottom: none;\n}\n\n.form-row label {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    font-weight: 400;\n    min-width: 200px;\n    flex-shrink: 0;\n    white-space: nowrap;\n    background-color: transparent !important;\n    background: transparent !important;\n    padding: 0 20px;\n    height: 53px;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n}\n\n.form-row .required {\n    color: var(--red, #fa2d00);\n}\n\n.input-wrapper {\n    flex: 1;\n    height: 53px;\n    position: relative;\n    min-width: 0;\n}\n\n.form-row input {\n    background: var(--white, #ffffff);\n    border-radius: 5px;\n    border-style: solid;\n    border-color: var(--grey1, #d7d7d7);\n    border-width: 1px;\n    width: 100%;\n    height: 53px;\n    padding: 0 16px;\n    box-sizing: border-box;\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    color: var(--darkgrey3, #000000);\n}\n\n.form-row input::placeholder {\n    color: var(--grey4, #a1a1a1);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n}\n\n.form-display-value {\n    background: var(--white, #ffffff);\n    border-radius: 5px;\n    border-style: solid;\n    border-color: var(--grey1, #d7d7d7);\n    border-width: 1px;\n    width: 100%;\n    height: 53px;\n    padding: 0 16px;\n    box-sizing: border-box;\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    color: var(--darkgrey3, #000000);\n    display: flex;\n    align-items: center;\n}\n\n.phone-row {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    align-items: flex-start;\n    width: 100%;\n    position: relative;\n}\n\n.phone-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0;\n    flex: 1;\n    min-height: 53px;\n}\n\n.phone-group label {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    font-weight: 400;\n    min-width: 120px;\n    flex-shrink: 0;\n    white-space: nowrap;\n    background-color: transparent !important;\n    background: transparent !important;\n    padding: 0 20px;\n    height: 53px;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n}\n\n.phone-group .input-wrapper {\n    flex: 1;\n    height: 53px;\n    position: relative;\n    min-width: 0;\n}\n\n.phone-inputs {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.phone-inputs input {\n    flex-grow: 1;\n}\n.phone-inputs .mobile-label {\n    margin-bottom: 0;\n    margin-left: 20px;\n    flex-shrink: 0;\n}\n\n.co-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 60px;\n}\n\n.co-actions.space-between {\n    justify-content: space-between;\n}\n\n.confirm-btn-large {\n    background-color: #E84100;\n    color: white;\n    padding: 20px 80px;\n    border: none;\n    border-radius: 5px;\n    font-size: 20px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n/* Step 2 Styles */\n.attached-files-summary {\n    background-color: #f8f8f8;\n    padding: 20px;\n    margin-bottom: 40px;\n}\n\n.remove-file-btn {\n    background: var(--darkgrey3, #000000);\n    color: var(--white, #ffffff);\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s ease;\n}\n\n.remove-file-btn:hover {\n    background: #333333;\n}\n\n.file-item {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n}\n.file-item .file-status {\n    color: #E84100;\n}\n\n.user-info-summary {\n    border-top: 2px solid #222;\n}\n.info-row {\n    display: flex;\n    padding: 20px 10px;\n    border-bottom: 1px solid #eee;\n}\n.info-row .label {\n    flex-basis: 150px;\n    font-weight: 500;\n}\n\n.edit-btn-text {\n    background: none;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: 15px;\n    color: #555;\n}\n\n.back-btn, .confirm-btn {\n    padding: 15px 40px;\n    border-radius: 5px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    border: 1px solid;\n    width: 250px;\n    text-align: center;\n}\n\n.back-btn {\n    background-color: white;\n    border-color: #ccc;\n    color: #333;\n}\n\n.confirm-btn {\n    background-color: #E84100;\n    border-color: #E84100;\n    color: white;\n}\n\n\n.co-actions .edit-btn-text.right {\n    background: none;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: 15px;\n    color: #555;\n    margin-left: auto;\n}\n\n.centered-content {\n    padding: 100px 0;\n    text-align: center;\n}\n.centered-content .co-title { text-align: center; }\n.centered-content .co-description {\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n    border-bottom: none;\n}\n.black-btn {\n    background-color: #222;\n    color: white;\n    border: none;\n    padding: 15px 60px;\n    font-size: 18px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.black-btn:hover {\n    background-color: #333;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.2);\n}\n\n/* 커스텀 주문 2단계와 3단계 버튼들 */\n.button-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 0;\n    margin-bottom: 0;\n    width: 100%;\n    gap: 20px;\n}\n\n.button-container .submit-btn {\n    background: var(--primary, #e84200);\n    border-radius: 5px;\n    padding: 15px;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    height: 53px;\n    border: none;\n    cursor: pointer;\n}\n\n.button-container .submit-btn div {\n    color: var(--white, #ffffff);\n    text-align: center;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.prev-btn, .submit-btn, .reset-btn, .list-btn {\n    padding: 15px 40px;\n    border-radius: 6px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: all 0.3s ease;\n    flex: 1;\n}\n\n.prev-btn {\n    background-color: #f8f9fa;\n    color: #333;\n    border: 1px solid #dee2e6;\n}\n\n.prev-btn:hover {\n    background-color: #e9ecef;\n    border-color: #adb5bd;\n    transform: translateY(-1px);\n}\n\n.submit-btn, .reset-btn, .list-btn {\n    background-color: #E84100;\n    color: white;\n    box-shadow: 0 2px 4px rgba(232, 65, 0, 0.2);\n}\n\n.submit-btn:hover, .reset-btn:hover, .list-btn:hover {\n    background-color: #d73502;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(232, 65, 0, 0.3);\n}\n\n.submit-btn:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n/* Step 2 확인 페이지 스타일 */\n.confirmation-section {\n    background-color: #ffffff;\n    padding: 30px;\n    border-radius: 8px;\n    margin-bottom: 30px;\n}\n\n.confirmation-section h3 {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0 0 20px 0;\n    padding-bottom: 15px;\n    border-bottom: 2px solid var(--darkgrey1, #222222);\n}\n\n.info-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n}\n\n.info-item {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 16px;\n    line-height: 1.6;\n}\n\n.info-item strong {\n    font-weight: 600;\n    margin-right: 10px;\n}\n\n.files-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.file-confirmation-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px;\n    background-color: white;\n    border-radius: 4px;\n}\n\n.file-confirmation-item .file-name {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 16px;\n}\n\n.file-confirmation-item .file-size {\n    color: var(--grey4, #a1a1a1);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 14px;\n}\n\n.additional-request-text {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 16px;\n    line-height: 1.6;\n    white-space: pre-wrap;\n    margin: 0;\n}\n\n/* 완료 페이지 스타일 */\n.completion-message {\n    text-align: center;\n    padding: 60px 20px;\n    background-color: #ffffff;\n    border-radius: 8px;\n    margin-bottom: 40px;\n}\n\n.completion-title {\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--darkgrey3, #000000);\n    margin: 0 0 20px 0;\n    font-family: \"Inter-Bold\", sans-serif;\n}\n\n.completion-description {\n    font-size: 16px;\n    line-height: 1.6;\n    margin: 0;\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Regular\", sans-serif;\n}\n\n.success-icon {\n    font-size: 60px;\n    color: #28a745;\n    margin-bottom: 20px;\n}\n\n.completion-message p {\n    font-size: 18px;\n    line-height: 1.5;\n    margin-bottom: 10px;\n    color: #333;\n}\n\n.step3-button {\n    justify-content: center;\n}\n\n.back-to-list-btn {\n    background-color: var(--darkgrey3, #000000);\n    color: var(--white, #ffffff);\n    border: none;\n    border-radius: 5px;\n    padding: 15px 40px;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-family: \"Inter-Bold\", sans-serif;\n    min-width: 200px;\n}\n\n.back-to-list-btn:hover {\n    background-color: #333333;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .custom-order-page {\n        padding: 20px;\n    }\n\n    .co-title {\n        font-size: 30px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .custom-order-page {\n        padding: 15px;\n        max-width: 100%;\n    }\n    \n    .co-step-container {\n        padding: 0 15px;\n        max-width: 100%;\n    }\n\n    .co-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n        padding: 0 5px;\n    }\n\n    .co-title {\n        font-size: 20px;\n        margin-bottom: 8px;\n    }\n    \n    .co-description {\n        font-size: 14px;\n        padding-bottom: 20px;\n        margin-bottom: 30px;\n    }\n    \n    .co-progress-indicator {\n        width: 100%;\n        max-width: 100%;\n        height: auto;\n        min-height: 90px;\n        margin: 40px auto;\n        padding: 0 10px;\n        box-sizing: border-box;\n    }\n    \n    .co-progress-line-bg {\n        width: calc(100% - 25px);\n        left: 12.5px;\n        right: 12.5px;\n    }\n    \n    .co-progress-line-fill {\n        left: 12.5px;\n    }\n    \n    .co-progress-line-fill.step2 {\n        width: calc(50% - 12.5px);\n    }\n    \n    .co-progress-line-fill.step3 {\n        width: calc(100% - 25px);\n    }\n    \n    .co-progress-indicator .step-item {\n        max-width: calc(33.333% - 5px);\n        padding: 0 5px;\n        box-sizing: border-box;\n    }\n\n    .co-progress-indicator .step-item:nth-child(3) {\n        left: 12.5px;\n        transform: translateX(-50%);\n    }\n    \n    .co-progress-indicator .step-item:nth-child(4) {\n        left: 50%;\n        transform: translateX(-50%);\n    }\n    \n    .co-progress-indicator .step-item:last-child {\n        right: 12.5px;\n        transform: translateX(50%);\n    }\n\n    .step-label {\n        font-size: 12px;\n        line-height: 1.3;\n        white-space: normal;\n        word-break: keep-all;\n        max-width: 100%;\n        overflow-wrap: break-word;\n        width: 100%;\n        display: block;\n        margin: 0 auto;\n    }\n    \n    .file-upload-section {\n        padding: 30px 15px;\n        margin-bottom: 30px;\n        min-height: 200px;\n    }\n    \n    .upload-text-wrapper {\n        gap: 8px;\n    }\n\n    .upload-main-text,\n    .upload-note {\n        font-size: 14px;\n    }\n\n    .upload-btn {\n        width: 100%;\n        max-width: 249px;\n        height: 48px;\n    }\n    \n    .upload-btn div {\n        font-size: 16px;\n    }\n    \n    .form-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 15px;\n        margin-bottom: 30px;\n    }\n    \n    .form-header h3 {\n        font-size: 20px;\n    }\n\n    .form-header-inner {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 15px;\n        width: 100%;\n    }\n\n    .load-info-btn {\n        position: static;\n        width: 100%;\n        max-width: 178px;\n        height: 48px;\n        font-size: 16px;\n        bottom: 0;\n    }\n    \n    .form-grid {\n        padding: 0;\n        gap: 20px;\n        margin-bottom: 30px;\n    }\n\n    .form-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n        min-height: auto;\n        width: 100%;\n    }\n\n    .form-row label {\n        position: static;\n        min-width: auto;\n        width: 100%;\n        margin-bottom: 5px;\n        padding: 12px 15px;\n        height: auto;\n        font-size: 14px;\n        background-color: transparent !important;\n        background: transparent !important;\n    }\n\n    .input-wrapper {\n        width: 100%;\n        margin-left: 0;\n        height: auto;\n    }\n    \n    .form-row input {\n        height: 48px;\n        font-size: 16px;\n        padding: 0 12px;\n    }\n    \n    .form-row input::placeholder {\n        font-size: 16px;\n    }\n\n    .form-display-value {\n        height: 48px;\n        font-size: 16px;\n        padding: 0 12px;\n    }\n\n    .phone-row {\n        flex-direction: column;\n        gap: 20px;\n        width: 100%;\n    }\n\n    .phone-group {\n        width: 100%;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n\n    .phone-group label {\n        min-width: auto;\n        width: 100%;\n        margin-bottom: 5px;\n        padding: 12px 15px;\n        height: auto;\n        font-size: 14px;\n        background-color: transparent !important;\n        background: transparent !important;\n    }\n    \n    .phone-group .input-wrapper {\n        width: 100%;\n    }\n\n    .co-actions {\n        flex-direction: column;\n        gap: 10px;\n        margin-top: 30px;\n        width: 100%;\n    }\n\n    .co-actions.space-between {\n        flex-direction: column-reverse;\n    }\n\n    .confirm-btn-large, .back-btn, .confirm-btn, .black-btn {\n        width: 100%;\n        padding: 15px;\n        font-size: 16px;\n    }\n\n    .button-container {\n        width: 100%;\n        padding: 0;\n        gap: 10px;\n    }\n    \n    .button-container .submit-btn,\n    .button-container .prev-btn,\n    .button-container .reset-btn,\n    .button-container .list-btn {\n        flex: 1;\n        width: auto;\n        min-width: 0;\n        height: 48px;\n        padding: 15px 20px;\n        font-size: 16px;\n    }\n    \n    .button-container .submit-btn div {\n        font-size: 16px;\n    }\n\n    .info-row {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 15px 10px;\n        gap: 8px;\n    }\n    \n    .info-row .label {\n        flex-basis: auto;\n        margin-bottom: 5px;\n        font-size: 14px;\n    }\n    \n    .attached-files-summary {\n        padding: 15px;\n        margin-bottom: 30px;\n    }\n    \n    .file-item {\n        flex-direction: column;\n        gap: 8px;\n        padding: 12px;\n    }\n\n    .centered-content {\n        padding: 40px 0;\n    }\n    \n    .completion-message {\n        padding: 40px 15px;\n        margin-bottom: 30px;\n    }\n\n    .completion-title {\n        font-size: 20px;\n    }\n\n    .completion-description {\n        font-size: 14px;\n        line-height: 1.5;\n    }\n    \n    .completion-message p {\n        font-size: 16px;\n    }\n\n    .back-to-list-btn {\n        width: 100%;\n        max-width: 100%;\n        padding: 15px 20px;\n        font-size: 16px;\n    }\n\n    .step3-button {\n        width: 100%;\n    }\n\n    .confirmation-section {\n        padding: 20px 15px;\n        margin-bottom: 20px;\n    }\n\n    .confirmation-section h3 {\n        font-size: 20px;\n        margin-bottom: 15px;\n        padding-bottom: 10px;\n    }\n\n    .info-grid {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n\n    .info-item {\n        font-size: 14px;\n    }\n\n    .file-confirmation-item {\n        padding: 8px;\n    }\n\n    .file-confirmation-item .file-name {\n        font-size: 14px;\n    }\n\n    .file-confirmation-item .file-size {\n        font-size: 12px;\n    }\n\n    .additional-request-text {\n        font-size: 14px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
